import React from 'react'
import './inlineValidation.scss'

const InlineValidation = ({formik, fieldId, fieldTouched, customMessage}) => {
    return (
        <div 
            className={`
            ${fieldTouched && 'fieldTouched-val'}
            inline-validation caption
            `}
        >
            {(formik.touched[fieldId] && 
                formik.errors[fieldId]) || 
                    customMessage && (
                    <span className="input-error-text">
                        {customMessage ? customMessage : formik.errors[fieldId]}
                    </span>
                )}
        </div>
    )
}

export default InlineValidation